let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("4ohKn")), load("29g81")]).then(() => parcelRequire('2F6ud'));